import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { withTranslation } from 'react-i18next'

import { hasAbilityToSelectNewProTrack, getIdentityOrganizationName } from 'store/entities/identity/selectors'
import UserProTrackSelectNew from './UserProTrackSelectNew'
import { push } from 'connected-react-router'

const mapStateToProps = createStructuredSelector({
  hasAbilityToSelectNewProTrack: hasAbilityToSelectNewProTrack,
  organizationName: getIdentityOrganizationName,
})

const mapDispatchToProps = dispatch => ({
  goToSelectProTrack: () => dispatch(push('/select-protrack')),
})

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('user')(UserProTrackSelectNew))
